import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MuiThemeProvider } from "@material-ui/core/styles";
import theme from "./theme";
import { HashRouter as Router } from "react-router-dom";
import ProvideStore from "./Dependencies/ProvideStore";
import './Assets/font/FontsFree-Net-SFProText-Regular.ttf'

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ProvideStore>
        <MuiThemeProvider theme={theme}>
          <App />
        </MuiThemeProvider>
      </ProvideStore>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
